import { DateTime } from "luxon";

export class UserUtils {
	/**
	 * Calculates the age of a user by using an ISO Date format string
	 * @param dob
	 */
	static calculateAge(dob: string): number {
		const x = DateTime.fromFormat(UserUtils.normalizeDOB(dob), "yyyy-MM-dd");
		return x.isValid ? Math.floor(Math.abs(x.diffNow("years").years)) : NaN;
	}

	/**
	 * Normalizes the dob input string in the event it is in an unexpected format
	 * @param dob
	 * @returns The normalized dob string in ISO format e.g. "yyyy-MM-dd", otherwise the original string
	 */
	static normalizeDOB(dob: string): string {
		if (dob) {
			dob = dob.trim();
			if (dob.includes("/")) {
				const x = DateTime.fromFormat(dob.substring(0, 10), "M/d/yyyy");
				return x.isValid ? x.toISODate() : dob;
			}
			if (dob.includes("T")) {
				return UserUtils.normalizeDOB(dob.split("T")[0]);
			}
			if (dob.includes("-")) {
				const x = DateTime.fromFormat(dob.substring(0, 10), "yyyy-MM-dd");
				return x.isValid ? x.toISODate() : dob;
			}
		}
		return dob;
	}

	/**
	 * Formats an ISO date string in the format of "yyyy-MM-dd" to a human readable date string with ordinal suffix
	 * @param date
	 * @returns The formatted date string with ordinal suffix e.g. "January 1st 2025", otherwise the original string
	 */
	static formatISODateWithOrdinal(date: string): string {
		const x = DateTime.fromFormat(date, "yyyy-MM-dd");
		if (!x.isValid) return date;

		const day = x.day;
		const suffix = UserUtils.getDaySuffix(day);
		return x.toFormat(`MMMM d'${suffix}' yyyy`);
	}

	/**
	 * Returns the appropriate suffix for a day number (1st, 2nd, 3rd, 4th, etc.)
	 * @param day The day number
	 */
	private static getDaySuffix(day: number): string {
		if (day >= 11 && day <= 13) return "th";

		switch (day % 10) {
			case 1:
				return "st";
			case 2:
				return "nd";
			case 3:
				return "rd";
			default:
				return "th";
		}
	}
}
